import React from 'react';
import FloatingLabel from "floating-label-react";
import { InputMask } from '@react-input/mask';

import classNames from 'classnames';
import styles from './index.module.scss';

const Input = ({ className, type = "text", floatingLabel = false, mask, ...rest }) => {
    const inputClassName = classNames(className, styles.input, `ab-mozart-input-${type}`);

    if (type === 'phone' && mask) {
        return <InputMask mask={mask} replacement={{ _: /\d/ }} className={inputClassName} {...rest} />;
    }

    if (floatingLabel) {
        return <FloatingLabel type={type} className={classNames(className, styles.floatingLabel)} {...rest}/>
    }

    return <input type={type} className={inputClassName} {...rest} />;
};

export default Input;
